import { render, staticRenderFns } from "./SalesRecordLinks.vue?vue&type=template&id=0612e84d&"
import script from "./SalesRecordLinks.vue?vue&type=script&lang=js&"
export * from "./SalesRecordLinks.vue?vue&type=script&lang=js&"
import style0 from "./SalesRecordLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports